import React, { useState , useContext} from 'react';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import '../styles/Login.css';
import logo from '../images/logo_1.png'
import { AuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);  // Estado para manejar errores
  const navigate = useNavigate(); // Usa el hook de navegación

  const { loginUser } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Intenta iniciar sesión
    const result = await loginUser(username, password);

    // Si el inicio de sesión fue exitoso, redirige a la ruta '/'
    if (result) {
      navigate('/');  // Redirige a la página principal
    } else {
    setError('Credenciales incorrectas. Por favor, intenta de nuevo.');
    }
  };

  return (
        <div className="login-page">
        <div className="login-container">
            {/* Logo */}
            <img src={logo} alt="Logo" className="login-logo" height={100} style={{ width:"140px" }} />

            {/* Formulario de Login */}
            <h2 className="login-title">Bienvenido</h2>
            <p className="login-subtitle">Inicia sesión para continuar</p>
            <form onSubmit={handleSubmit}>
            {/* Campo de Usuario */}
            <div style={{ display: "flex", justifyContent: "center", marginBottom: "1.2rem", minWidth: "100%" }}>
                <InputText
                    id="username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    placeholder="Usuario"
                    style={{ textAlign:"center",fontSize:"0.9rem", width:"100%"}} // Asegura el ancho completo
                />
            </div>

            {/* Campo de Contraseña */}
            <div style={{ display: "flex", justifyContent: "center", marginBottom: "1.2rem", minWidth: "100%" }}>
                <Password
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Contraseña"
                    feedback={false}
                    toggleMask
                    className="w-full"
                    inputClassName='w-full'
                    pt={{ iconField: { root: { className: 'w-full' } } }}
                    inputStyle={{ textAlign:"center",fontSize:"0.8rem"}}
                />
            </div>

            {/* Botón de Iniciar Sesión */}
            <Button
                label="Iniciar Sesión"
                type="submit"
                className="p-button p-button-block p-button-lg login-button"
                size='small'
            />
            </form>
            {/* Mostrar error debajo del formulario si lo hay */}
                    {error && (
                    <div style={{ color: 'red', textAlign: 'center', marginTop: '1rem' }}>
                        {error}
                    </div>
            )}
        </div>
        </div>

  );
};

export default Login;
